type BreakpointValueKey<T extends string | number | symbol> = T extends string
  ? `${T}Value`
  : never

type BreakpointKey<T extends string | number | symbol> = T extends string
  ? T | BreakpointValueKey<T>
  : never

export type Breakpoints<T extends { [key: string]: number }> = string[] & {
  [K in BreakpointKey<keyof T>]: K extends BreakpointValueKey<keyof T>
    ? number
    : string
}

export const createBreakpoints = <T extends { [key: string]: number }>(
  breakpoints: T,
  unit = 'px',
): Breakpoints<T> => {
  const stringLiteralBpObj = Object.fromEntries(
    Object.entries(breakpoints).flatMap(([k, v]) => {
      const val = `${v}${unit}`
      return [
        [k, val],
        [`${k}Value`, v],
      ]
    }),
  )

  const ret = Object.assign(
    Object.values(breakpoints).map((v) => `${v}${unit}`),
    stringLiteralBpObj,
  )

  return ret as Breakpoints<T>
}
